import { useEffect, useState } from "react";
import { RecruitmentForm } from "./RecruitmentForm";
import axios from "axios";
import { API_BASE_URL } from "../../../config/api";

export const RecruitmentPage = () => {
  const [requests, setRequests] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSuccess = ({ message }) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage("")); // optional auto-clear
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${API_BASE_URL}/api/requests`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("Full API response:", res.data);
        setRequests(res.data.data);
      })
      .catch((err) => console.error("Error fetching requests:", err));
  }, []);

  return (
    <div className="flex flex-1 w-full h-full">
      <div className="flex flex-col w-full">
        {successMessage && (
          <div className="p-2 mx-4 mt-4 mb-2 text-green-700 bg-green-100 border border-green-300 rounded">
            {successMessage}
          </div>
        )}
        <RecruitmentForm onSuccess={handleSuccess} />
      </div>
    </div>
  );
};
